import API from './API.ts'

export default {
  //
  // GET
  //
  getEmailHtml (id) {
    return API.httpClient.get(`email/${id}`)
  }

  //
  // POST
  //
}
